import { render, staticRenderFns } from "./FormularioComponent.vue?vue&type=template&id=8d6db5fa&"
import script from "./FormularioComponent.vue?vue&type=script&lang=ts&"
export * from "./FormularioComponent.vue?vue&type=script&lang=ts&"
import style0 from "./FormularioComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports